var XPortal = XPortal || {};

XPortal.PageHeader = (function () {
    var self =
    {
        body: 'body',
        header: '.header-wrapper',
        pageHeader: '.edit-btns-wrapper',
        pageContent: '.content-detail',
        Init: function () {
            const isDetailPage = $(self.body).hasClass('xpage-xentitydetail');
            if (isDetailPage) {
                XPortal.PageHeader.initFixedPageHeader();
            } 
        },
        initFixedPageHeader: function () {
            const windowWidth = $(window).width();
            const $body = $(self.body);
            const $headerWrapper = $(self.header);
            const $pageHeader = $(self.pageHeader);
            const $pageContent = $(self.pageContent);
            const activeClass = 'page-header-sticky';
            const pageContentActiveclass = 'page-header-sticky';
            const minimazeMainHeaderClass = 'header-wrapper_min';
            const bodyHasMinimazeMainHeaderClass = 'has-header-wrapper-min';
            const headerHeightOffset = windowWidth < 767 ? 8 : 22;

            if (!$pageHeader.length > 0) return;

            const headerHeight = $headerWrapper.outerHeight() - headerHeightOffset || 0;

            const pageHeaderOffset = $pageHeader.offset().top;
            const pageHeaderHeight = $pageHeader.outerHeight() || 0;

            let lastScrollTop = 0;

            function onScroll() {
                const scrollTop = $(window).scrollTop();
                // Detectiong scroll direction
                if (scrollTop > lastScrollTop) {
                    $pageHeader.removeClass('scroll-top').addClass('scroll-bottom');
                    $pageContent.removeClass(pageContentActiveclass).css('padding-top', 0);
                } else {
                    $pageHeader.removeClass('scroll-bottom').addClass('scroll-top');
                }
        
                if (scrollTop >= pageHeaderOffset - headerHeight) {
                    $pageHeader.addClass(activeClass).css('top',headerHeight );
                    $headerWrapper.addClass(minimazeMainHeaderClass);
                    $pageContent.addClass(pageContentActiveclass).css('padding-top', pageHeaderHeight);
                    $body.addClass(bodyHasMinimazeMainHeaderClass);
                } else {
                    $pageHeader.removeClass(activeClass).css('top',0 );
                    $headerWrapper.removeClass(minimazeMainHeaderClass);
                    $pageContent.removeClass(pageContentActiveclass).css('padding-top', 0);
                    $body.removeClass(bodyHasMinimazeMainHeaderClass);
                }
                lastScrollTop = scrollTop;
            }
        
            $(window).on('scroll', onScroll);
            onScroll();
        },
        initFixedSiteHeader: function () {
            const $body = $(self.body);
            const $headerWrapper = $(self.header);
            const minimazeMainHeaderClass = 'header-wrapper_min';
            const bodyHasMinimazeMainHeaderClass = 'has-header-wrapper-min';
            const headerHeight = $headerWrapper.outerHeight() - 22 || 0;

            function onScroll() {
                const scrollTop = $(window).scrollTop();
        
                if (scrollTop >= headerHeight + 30) {
                    $headerWrapper.addClass(minimazeMainHeaderClass);
                    $body.addClass(bodyHasMinimazeMainHeaderClass);
                } else {
                    $headerWrapper.removeClass(minimazeMainHeaderClass);
                    $body.removeClass(bodyHasMinimazeMainHeaderClass);
                }
            }
        
            $(window).on('scroll', onScroll);
            onScroll();

        }
    };

    return self;
}());
